<template>
  <div class="demo">
    <div v-if="scrollList.length > 0">
      <ul class="list"
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="loading"
      infinite-scroll-distance="150">
      <li v-for="(item,i) in scrollList" @click="skip(item.url, item.id, item.pptNum, item.status, item.courseId, item.type, item.subjectType, item.service_type, item.uid, item.liveAcCount, item.courseAcCount)">
        <div class="left">
          <img v-if="item.middlePicture || item.organizerLogo"
          :src="getImgUrl(item.middlePicture)">
          <p v-if="item.status == '直播中'"><img src="./../../../static/img/livving.png" style="height: 15px" alt=""></p>
          <p v-if="item.status == '直播'"><img src="./../../../static/img/living.png" style="height: 15px" alt=""></p>
          <p v-if="item.status == '即将开始'"><img src="./../../../static/img/nostart.png" style="height: 15px" alt=""></p>
          <p v-if="item.subjectType == 'live'"><img src="./../../../static/img/living.png" style="height: 15px" alt=""></p>
          <p v-if="item.status == '已结束'"><img src="./../../../static/img/livend.png" style="height: 15px" alt=""></p>
          <p v-if="item.status == '结束'"><img src="./../../../static/img/livend.png" style="height: 15px" alt=""></p>
          <p v-if="item.status == '视频回放'"><img src="./../../../static/img/replay.png" style="height: 15px;" alt=""></p>
          <p v-if="item.status == '回放'"><img src="./../../../static/img/replay.png" style="height: 15px" alt=""></p>
          <div v-if="play" class="Play"><img src="./../../../static/img/watch.png" alt=""></div>
        </div>
        <div class="right">
          <h3 class="title != null">{{cutStr(item.title)}}</h3>
          <p class="name" v-if="item.teacher != null">{{ item.teacher }}</p>
          <p class="name" v-if="item.teacherArr != null">大　咖：{{ item.teacherArr.truename }} {{ item.teacherArr.title }}</p>
          <p class="organizer" v-if="item.subtitle != null">{{ item.subtitle }}</p>
          <p class="organizer" v-if="item.organizer"> <span v-show="showOrg">主办方：</span>{{ item.organizer }}</p>
          <p class="livetime" v-if="item.liveTime != null && !item.pptNum == null && item.price == null">
            {{item.liveTime }}
          </p>
          <p class="livetime" v-if="item.liveTime && (item.type || item.livetype == 'meeting')">
            {{item.liveTime }}  <!--这里2019-02-22修改-->
          </p>
          <p class="livetime" v-if="item.liveTime != null && !item.pptNum == null && item.price != null && item.price==0 && item.type!='normal'">时　间：{{
          item.liveTime }}</p>
          <p class="liveTime" v-if="item.pptNum != null && item.liveTime != null">时　间：{{ item.liveTime }}<span><img src="./../../assets/img/ppt_ico.png" style="height: 14px" /> {{ item.pptNum }}个</span></p>
          <p class="hitNum" v-if="item.price != null && item.organizerInfo == null">{{ item.hitNum }}人已观看<span
            v-if="item.price != 0 && item.price != null">￥{{ item.price }}元</span></p>
            <p class="hitNum" v-if="item.usedCount != null">{{ item.usedCount}}</p>
            <p class="pptNum" v-if="item.pptNum">{{item.pptNum}}</p>
          </div>
        </li>


      </ul>
    </div>
    <p v-if="nodata" class="noData">暂无数据</p>
  </div>
</template>
<script>
  export default {
    name: 'scroll-bar',
    data() {
      return {
        dataType: '', // 这里需要把视频列表区分开 dataType video 为视频列表数据
        scrollList: [],
        currentPage: 1,
        toggle: true,
        nomore: false,
        imgurl: '',
        nodata: false,
        showOrg: true // 显示'主办方'三个字
      }
    },
    props: ["url", "tech", "play", "axiosUrl", "uType"],
    created() {
      this.initData()
    },
    computed: {
      getCommunity() {
        return this.$store.state.community;
      }
    },
    methods: {
      // 初始化
      initData () {
        window.localStorage.removeItem('url')
        let that = this;
        that.scrollList = []
        that.dataType = ''
        if (that.url == 'oldapi/mobile/subject/?') {
          that.currentPage = 0
        }
        this.$axios
        .get(that.url + "page=" + that.currentPage)
        .then(res => {

          if (typeof res.data.data.list === "object") {
            that.scrollList = res.data.data.list;
            this.$store.state.community = res.data.data;
          } 
          else if (typeof res.data.data.courseList === "object") {
            that.scrollList = res.data.data.courseList;
            this.$store.state.community = res.data.data;
          } 
          else if (typeof res.data.data.pptList === "object" && res.data.data.pptList !== null) {
            that.scrollList = res.data.data.pptList;
            this.$store.state.community = res.data.data;
          } 
          else if (typeof res.data.data.categoryList === 'object' && res.data.data.categoryList !== null) {
            that.scrollList = res.data.data.categoryList
          } 
          else if (typeof res.data.data.videoList === 'object' && res.data.data.videoList !== null) {
            that.scrollList = res.data.data.videoList
            that.dataType = 'video'
          } 
          else if (typeof res.data.data.liveList === 'object' && res.data.data.liveList !== null) {
            that.scrollList = res.data.data.liveList
          }
          else if (that.url == 'api/recommend/getData?') { // 推荐活动
              var scrollList_son=[];
              var scrollList_sons={};

            if (typeof res.data.data.act === 'object'&&res.data.data.act!=null&&res.data.data.act.length>0){

              for(var i=0;i<res.data.data.act.length;i++){

                scrollList_sons={};
                scrollList_sons.livetype = 'meeting';
                scrollList_sons.id = res.data.data.act[i].id;
                scrollList_sons.type = res.data.data.act[i].type;
                scrollList_sons.title = res.data.data.act[i].title;
                scrollList_sons.liveTime = res.data.data.act[i].liveTime;
                scrollList_sons.middlePicture = res.data.data.act[i].poster;
                scrollList_sons.organizer = res.data.data.act[i].sponsor.name;
                scrollList_sons.url = 'https://www.itdks.com/Home/mobile/detail';
                scrollList_son.push(scrollList_sons);

              }
                that.scrollList = scrollList_son;
            }

              if(typeof res.data.data.live === 'object'&&res.data.data.live!=null&&res.data.data.live.length>0){

                for(var j=0;j<res.data.data.live.length;j++){

                  scrollList_sons={};
                  scrollList_sons.type = 'bjy';
                  scrollList_sons.livetype = 'meeting';
                  scrollList_sons.id = res.data.data.live[j].id;
                  scrollList_sons.status = res.data.data.live[j].status;
                  scrollList_sons.title = res.data.data.live[j].name;
                  scrollList_sons.liveTime = res.data.data.live[j].liveTime;
                  scrollList_sons.middlePicture = res.data.data.live[j].poster;
                  scrollList_sons.organizer = res.data.data.live[j].sponsor.real_name;
                  scrollList_sons.url = 'https://www.itdks.com/Home/mobile/detail';
                  scrollList_son.push(scrollList_sons);

                }

              }

              that.scrollList = scrollList_son;



            
          }
          else if (that.url == 'api/Subject/getSubjects?status=1&') { // 专题
            if (res.data.data.subjectList != null) {
              res.data.data.subjectList.forEach(item => {
                item.title = item.name;
                item.subtitle = item.creator_name;
                if (item.poster.indexOf('itdks.com') > -1) {
                  item.middlePicture = item.poster
                } else {
                  item.middlePicture = item.poster.indexOf('https://') == -1 ? 'https://www.itdks.com/' + item.poster : item.poster;
                }
              });
              that.scrollList = res.data.data.subjectList
            }
          }
          else {
            that.scrollList = res.data.data;
          }
          if (that.scrollList[0].organizer) {
            if (that.scrollList[0].organizer.indexOf('主办方') == 0) {
              this.showOrg = false
            }
          }
          that.currentPage++;
          if (that.scrollList.length && that.scrollList.length > 0) {
          } else {
            that.nodata = true
          }
        })
        .catch(err => {
          that.nodata = true
        })
        window.localStorage.setItem('url', this.url)
      },
      loadMore: function () {
        if (this.nomore) {
          return;
        }
        if (this.tech) {
          return;
        }
        if (!this.toggle) {
          return;
        }
        if (this.url == 'oldapi/mobile/subject/?') {
          if (this.currentPage == 0) {
            return;
          }
        } else {
          if (this.currentPage == 1) {
            return;
          }
        }
        this.toggle = false;
        let that = this;
        this.loading = true;
        setTimeout(() => {
          this.$axios.get(that.url + "page=" + that.currentPage).then(res => {
            that.toggle = true;
            if (res.data.data.length == 0) {
              that.nomore = true;
            }
            if (res.data.data[0]){
              res.data.data.forEach(item =>{
                item.middlePicture = 'http://static.itdks.com' + item.middlePicture
              })
            }
            if (typeof res.data.data.categoryList === 'object' && res.data.data.categoryList !== null) {
              that.scrollList = [...that.scrollList, ...res.data.data.categoryList]
            }else if (typeof res.data.data.pptList === "object" && res.data.data.pptList !== null) {
              that.scrollList = [...that.scrollList, ...res.data.data.pptList]
            } else if (typeof res.data.data.videoList === 'object' && res.data.data.videoList !== null) {
              that.scrollList = [...that.scrollList, ...res.data.data.videoList]
            } else if (typeof res.data.data.list == "object") {
              if (res.data.data.list.length == 0) {
                that.nomore = true;
              }
              that.scrollList = that.scrollList.concat(res.data.data.list);
            } else if (typeof res.data.data.liveList === 'object' && res.data.data.liveList !== null) {
              that.scrollList = [...that.scrollList, ...res.data.data.liveList]
            } else {
              // that.scrollList = that.scrollList.concat(res.data.data);
            }
            if (that.url == 'api/Subject/getSubjects?status=1&') { // 专题
              if(res.data.data.subjectList !== null) {
                res.data.data.subjectList.forEach(item => {
                  item.title = item.name;
                  item.subtitle = item.creator_name;
                  if (item.poster.indexOf('itdks.com') > -1) {
                    item.middlePicture = item.poster
                  } else {
                    item.middlePicture = item.poster.indexOf('https://') == -1 ? 'https://www.itdks.com/' + item.poster : item.poster;
                  }
                })
                that.scrollList = [...that.scrollList, ...res.data.data.subjectList];
              } else {
                this.nomore = true
              }
            }
            that.currentPage++;
            this.loading = false;
          })
        }, 100)
      },
      // 剪切多余的显示不出的文字
      cutStr(str) {
        if (str.length > 23) {
          var newStr = str.substr(0, 25) + '...';
          return newStr
        } else {
          return str
        }
      },

      skip (url, aid, test, status, courseId, type, subjectType, serviceType, uid, liveAcCount, courseAcCount) {

        if (url == 'https://www.itdks.com/Home/mobile/detail'){//推荐活动

          if(type=='live'){

            window.location.href = 'https://www.itdks.com/Home/mobile/live_list?aid=' + aid;
            return

          }
          else{

            window.location.href = url+'?id=' + aid+'&type='+type;
            return

          }
    
        }

        if (this.url == 'api/Subject/getSubjects?status=1&') {  // 专题详情
          // this.$router.push({
          //   name: "subjectDetail",
          //   query: {id: aid, uid: uid}
          // })
          window.location.href = 'https://www.itdks.com/Home/mobile/topic_detail?id=' + aid;
          return
        }
        if (liveAcCount == '0' && courseAcCount == '0') {
          window.location.href = 'https://www.itdks.com/Home/mobile/detail?id=' + aid + '&type=meet';
          return
        }
        if (this.dataType == 'video') { // 视频列表直接跳转到php
          window.location.href = 'https://www.itdks.com/Home/mobile/detail?id=' + aid + '&type=normal'
        } else if(subjectType) { // 老专题
          window.localStorage.removeItem("techId")
          this.$router.push({
            name: "OldSubject",
            query: {aid: aid}
          })
          window.localStorage.setItem("techId", aid)
        } else {
          if (arguments[2] != null) {
            window.localStorage.removeItem("pptId")
            this.$router.push({
              name: "PPTdetail",
              query: {aid: aid}
            })
            window.localStorage.setItem("pptId", aid)
          } else {
            // this.$router.push({
            //   name: "Technicaltopic",
            //   query: {aid: aid}
            // })
            window.location.href = this.$bigapi+'/Home/Mobile/live_list?aid=' + aid;
          }
        }
      },
      // 拼接图片url
      getImgUrl(url){
        if (url.indexOf('itdks.com') == -1) {
          return 'http://static.itdks.com' + url
        } else {
          return url
        }
      },
    },
    watch: {
      url: function () {
        this.nodata = false;
        this.nomore = false;
        if (this.url == 'api/live/zsLiveList?') {
          return
        }
        this.dataType = ''
        this.scrollList = []
        this.nomore = false
        this.currentPage = 1
        let that = this;
        if (that.url == 'oldapi/mobile/subject/?') {
          that.currentPage = 0
        }
        this.$axios.get(that.url + "page=" + that.currentPage).then(res => {
          if (res.data.data[0]){
            res.data.data.forEach(item =>{
              item.middlePicture = 'http://static.itdks.com' + item.middlePicture
            })
          }
          that.scrollList = res.data.data
          if (typeof res.data.data.courseList == "object"){
            that.scrollList = res.data.data.courseList
          }
          if (typeof res.data.data.pptList === "object" && res.data.data.pptList !== null) {
            that.scrollList = res.data.data.pptList
          }
          if (typeof res.data.data.categoryList === 'object') {
            if (res.data.data.categoryList !== null) {
              that.scrollList = res.data.data.categoryList
            }
          }
          if (typeof res.data.data.videoList === 'object' && res.data.data.videoList !== null) {
            that.scrollList = res.data.data.videoList
            this.dataType = 'video'
          }
          if (typeof res.data.data.liveList === 'object' && res.data.data.liveList !== null) {
            that.scrollList = res.data.data.liveList
          }
            if (that.url == 'api/Subject/getSubjects?status=1&') { // 专题
              if(res.data.data.subjectList !== null) {
                // subjectList
                res.data.data.subjectList.forEach(item => {
                  item.title = item.name;
                  item.subtitle = item.creator_name;
                  if (item.poster.indexOf('itdks.com') > -1) {
                    item.middlePicture = item.poster
                  } else {
                    item.middlePicture = item.poster.indexOf('https://') == -1 ? 'https://www.itdks.com/' + item.poster : item.poster;
                  }
                });
                that.scrollList = res.data.data.subjectList
              }
            }
            that.currentPage++
            if (that.scrollList.length && that.scrollList.length > 0) {
            } else {
              that.nodata = true
            }
          });
      }
    }
  };
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  outline: none;
}
h3{
  margin-top: -8px;
}
.demo {
  margin-bottom: 92px;
}

.demo .list li {
  /* width: 750px; */
  height: 219px;
  padding: 25px 28px;
  box-sizing: border-box;
  border-bottom: 1px solid #dedede; /*no*/
  list-style: none;
  .left {
    width: 270px;
    height: 169px;
    line-height: 169px;
    margin-right: 10px;
    float: left;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    display: flex;
    > img {
      width: 270px;
      height: 169px;
    }
    .Play {
      position: absolute;
      width: 50px;
      height: 50px;
      right: 5px;
      bottom: 55px;
      z-index: 10;
      img {
        width: 50px;
        height: 50px;
      }
    }
    p {
      position: absolute;
      line-height: 30px;
      left: -10px;
      color: #fff;
      top: -2px;
      font-size: 18px; /*px*/
      padding: 2px 10px;
      img {
        width: auto;
      }
    }
    .living {
    }
    .begin {

    }
    .agin {
    }
    .end {
    }
  }
  .right {
    width: 390px;
    margin-left: 20px;
    float: right;
    font-size: 24px; /*px*/
    .title {
      font-size: 28px; /*px*/
      line-height: 56px;
      font-weight: 500;
      max-height: 66px;
      line-height: 33px;
      overflow: hidden;
    }
    .name {
      color: #f2845a;
      margin-top: 30px;
      margin-bottom: 6px;
      height: 30px;
      background: url(../../assets/img/title_ico.png) no-repeat left center;
      padding-left: 28px;
      background-size: 26px 26px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap
    }
    .organizer {
      color: #f3855d;
      height: 36px;
      margin-top: 12px;
      background: url(../../assets/img/title_ico.png) no-repeat left center;
      padding-left: 28px;
      background-size: 26px 26px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap
    }
    .liveTime,
    .hitNum {
      font-size: 24px !important;
      color: #8c8c8c;
      span {
        float: right;
      }
    }
    .liveTime,.livetime{
      background: url(./../../assets/img/time_ico.png) no-repeat left center;
      padding-left: 28px;
      background-size: 26px 26px;
    }
    .hitNum {
      margin-top: 14px;
      span {
        color: #fe0200;
        font-weight: 700;
      }
    }
    .livetime {
      color: #8c8c8c;
      span {
        float: right;
      }
    }
    .pptNum{
      position: absolute;
      width: 30px;
      height: 30px;
      right: 20px;
      background: url(./../../assets/img/ppt_ico.png) no-repeat left top;
      padding-left: 30px;
      background-size: 26px 26px;
      margin-top: 10px;
    }
  }
}
.noData{
  width: 60vw;
  height: 70vw;
  background: url("../../assets/img/nodata.png") no-repeat;
  background-size: 60vw 58vw;
  margin: 25vw auto 0;
  text-align: center;
  color: #ccc;
  line-height: 130vw;
}
</style>



// WEBPACK FOOTER //
// src/components/Commons/ScrollBars.vue